export abstract class LaunchScreenEnabledService {
  /** The screen this context rests on when a load flow ends with no explicit origin. */
  abstract restingScreen(launchScreenEnabled: boolean): string;
}
